import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/ai-personality"
    path="business/products/ai-personality"
    element={<AsyncPage />}
  />,
];
